"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineMotorClaimRequest = void 0;
const OnlineClaimRequest_1 = require("./OnlineClaimRequest");
class OnlineMotorClaimRequest extends OnlineClaimRequest_1.OnlineClaimRequest {
}
exports.OnlineMotorClaimRequest = OnlineMotorClaimRequest;
//# sourceMappingURL=OnlineMotorClaimRequest.js.map